module.exports = __webpack_public_path__ + "img/left-move-cursor.2faa661a.svg";